<template>

  <div>

      <el-steps :active="1" align-center>
        <el-step title="步骤 1" description="填写盘点信息"></el-step>
        <el-step title="步骤 2" description="分配盘点任务"></el-step>
      </el-steps>
      <el-contianer>
        <el-row>
          <el-col>
            <el-form
            ref="form"
            :rules = "rules"
            :model="form"
            label-width="120px"
            style="width: 45%;margin-left: 5%;margin-top: 2%;">
              <el-form-item label="盘点单名称" style="width: 65%;" prop="name">
                <el-input v-model.trim="form.name"></el-input>
              </el-form-item>
            <!-- <el-form-item label="盘点策略" prop="data1">
                <el-card shadow="hover" class="cardBolck">
                      <div style="font-size: 20px;">自定义</div>
                      <div style="font-size: 13px;">根据自己实际盘点的业务场景，自定义盘点规则</div>
                    </el-card>
              </el-form-item> -->

              <!-- <el-form-item label="盘点规则"  prop="type">
                <el-checkbox-group v-model="form.type" style="width: 20%;">
                  <el-checkbox label="允许手动盘点" name="type"></el-checkbox>
                  <el-checkbox label="盘点时允许修改资产信息" name="type"></el-checkbox>
                  <el-checkbox label="盘点时要求对每条资产拍照" name="type"></el-checkbox>
                  <el-checkbox label="盘点数据过滤[维修中]资产" name="type"></el-checkbox>
                  <el-checkbox label="盘点数据过滤[已处置]资产" name="type"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>  -->


              <el-form-item label="盘点单备注" prop="desc">
                <el-input type="textarea" v-model.trim="form.desc"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-contianer>

      <el-container style="margin-top: 3%;">
          <el-col :span="3" :offset="1">待盘点数据{{UseTableData.length}}条</el-col>
          <el-col :span="2" :offset="16">清空</el-col>

          <el-col :span="2":offset="0.5" style="color: brown;">
            <i @click="dialogVisible = true"
           class="el-icon-caret-bottom">选择资产</i></el-col>



          <el-dialog
            title="选择资产"
            :visible.sync="dialogVisible"
            width="60%">
           <el-container class="SelectBlock">
             <el-col class="FirstBlock" :sapn="3" >
               <el-dropdown @command="handleCommand">
                 <span class="el-dropdown-link">
                   选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
                 </span>
                 <el-dropdown-menu slot="dropdown">
                   <el-dropdown-item command="a">根据资产名称查询</el-dropdown-item>
                   <el-dropdown-item command="b">根据使用人姓名ID查询</el-dropdown-item>
                   <el-dropdown-item command="c">根据资产固定编码查询</el-dropdown-item>
                   <el-dropdown-item command="d">根据类别查询</el-dropdown-item>
                   <el-dropdown-item command="e">根据存放的区域查询</el-dropdown-item>
                   <el-dropdown-item command="f">根据单位查询</el-dropdown-item>
                   <el-dropdown-item command="g">根据资产状态查询</el-dropdown-item>
                 </el-dropdown-menu>
               </el-dropdown>


                 <el-input
                 v-if="selectCheck == 'a'"
                 style="width: 250px;"
                 v-model.trim="SForm.SpropertyName" placeholder="根据资产名称查询"></el-input>

                 <el-input
                 v-if="selectCheck == 'b'"
                 v-model.trim="SForm.SownerId"
                 style="width: 250px;"
                 :value="ManagerUser"
                 placeholder="根据使用人姓名ID查询">
                     <el-button
                       size="mini"
                        style="padding-right:10px"
                        slot="suffix"
                        type="text"
                       @click="dialogManager = true">选择</el-button> </el-input>
                       <el-dialog title="选择资产类别" :visible.sync="dialogManager" width="35%" append-to-body>
                         <el-tree
                           class ="TreeBlock"
                           :data="MangerData"
                           :filter-node-method="filterNode"
                           node-key="id"
                           @node-click="TreeMangerClick"
                           ref="tree"
                           :props="defaultProps"
                           default-expand-all:false
                           :expand-on-click-node="false">
                           <span class="custom-tree-node" slot-scope="{ node, data }">
                             <span>{{ node.label }}</span>
                           </span>
                         </el-tree>
                         <div slot="footer" class="dialog-footer">
                           <el-button @click="dialogManager = false">取 消</el-button>
                           <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                         </div>
                       </el-dialog>


                 <el-input
                 style="width: 250px;"
                 v-if="selectCheck == 'c'"
                 v-model.trim="SForm.SpropertyCode" placeholder="根据资产固定编码查询"></el-input>

                 <el-input
                 v-if="selectCheck == 'e'"
                 v-model.trim="SForm.SplaceId"
                 :value="SForm.SplaceRealId"
                 style="width: 250px;"
                 placeholder="根据存放的区域查询">
                     <el-button
                       size="mini"
                        style="margin-top: 5px;"
                        slot="suffix"
                        type="text"
                       @click="dialogPlace = true">选择</el-button></el-input>
                       <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%" append-to-body>
                         <el-tree
                           class ="TreeBlock"
                           :data="PlaceData"
                           :filter-node-method="filterNode"
                           node-key="id"
                           @node-click="TreePlaceClick"
                           ref="tree"
                           :props="defaultProps"
                           default-expand-all:false
                           :expand-on-click-node="false">
                           <span class="custom-tree-node" slot-scope="{ node, data }">
                             <span>{{ node.label }}</span>

                           </span>
                         </el-tree>
                         <div slot="footer" class="dialog-footer">
                           <el-button @click="dialogPlace = false">取 消</el-button>
                           <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                         </div>
                       </el-dialog>


                <el-input
                style="width: 250px;"
                v-if="selectCheck == 'd'"
                v-model.trim="SForm.SpropertyTypeId"
                placeholder="根据类别查询"
                :value="id">
                    <el-button
                      size="mini"
                       style="padding-right:10px"
                       slot="suffix"
                       type="text"
                      @click="dialogPropertyTypeId = true">选择</el-button> </el-input>
                      <el-dialog title="选择资产类别"
                      append-to-body
                      :visible.sync="dialogPropertyTypeId" width="25%">

                      <el-input
                        placeholder="输入关键字进行过滤"
                        v-model="filterText">
                      </el-input>
                        <el-tree
                          class ="TreeBlock"
                          :data="data"
                          :filter-node-method="filterNode"
                          node-key="id"
                          @node-click="TreePropertyClick"
                          ref="tree"
                          :props="defaultProps"
                          default-expand-all:false
                          :expand-on-click-node="false">
                          <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>

                          </span>
                        </el-tree>
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="dialogPropertyTypeId = false">取 消</el-button>
                          <el-button type="primary" @click="dialogPropertyTypeId = false;">确 定</el-button>
                        </div>
                      </el-dialog>








                 <el-select v-if="selectCheck == 'f'"
                 style="width: 250px;"
                 v-model.trim="SForm.SunitId" placeholder="根据单位查询">
                  <el-option
                  v-for="i in DUnit"
                  :label="i.unitName"
                  :key="i.unitId"
                  :value="i.unitId">
                  </el-option>

                  <el-select
                  v-if="selectCheck == 'h'"
                  style="width: 250px;"
                  v-model.trim="SForm.SoutProperty" placeholder="根据是否为帐外资产查询">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                 </el-select>
                 <el-select v-if="selectCheck == 'g'"
                 style="width: 250px;"
                 v-model.trim="SForm.SpropertyState" placeholder="是否为资产状态">
                   <el-option label="在用" value='1'></el-option>
                   <el-option label="待修" value='2'></el-option>
                   <el-option label="在修" value='3'></el-option>
                   <el-option label="备用" value='4'></el-option>
                   <el-option label="闲置" value='5'></el-option>
                   <el-option label="调剂" value='6'></el-option>
                   <el-option label="待报废" value='7'></el-option>

                   <el-option label="报废" value='8'></el-option>
                   <el-option label="待确定" value='9'></el-option>
                   <el-option label="在库" value='10'></el-option>

                 </el-select>
               <el-button type="primary" @click="select(1)">查询</el-button>
               <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
             </el-col>
           </el-container>















            <el-table
               :data="SelectData"
               style="width: 100%">
              <el-table-column
                label="资产固定编码"
                prop="propertyCode">
              </el-table-column>
              <el-table-column
                label="资产名称"
                prop="propertyName">
              </el-table-column>
              <el-table-column
                label="资产状态"
                prop="propertyState"
                >
                <template slot-scope="scope">
                  <el-tag
                  :type="scope.row.propertyState == 1?''
                  :(scope.row.propertyState==2?'success'
                  :(scope.row.propertyState==3?'info'
                  :(scope.row.propertyState==4?'danger'
                  :(scope.row.properyState==5?''
                  :(scope.row.properyState == 6?'success'
                  :(scope.row.properyState==7?'info'
                  :(scope.row.properyState==8?''
                  :(scope.row.properyState==9?'warning'
                  :(scope.row.properyState==10?'danger':'warning')))))))))"
                  effect="dark">
                    <div v-if="scope.row.propertyState == 1">在用</div>
                    <div v-if="scope.row.propertyState == 2">待修</div>
                    <div v-if="scope.row.propertyState == 3">在修</div>
                    <div v-if="scope.row.propertyState == 4">备用</div>
                    <div v-if="scope.row.propertyState == 5">闲置</div>
                    <div v-if="scope.row.propertyState == 6">调剂</div>
                    <div v-if="scope.row.propertyState == 7">待报废</div>
                    <div v-if="scope.row.propertyState == 8">报废</div>
                    <div v-if="scope.row.propertyState == 9">待确定</div>
                    <div v-if="scope.row.propertyState == 10">在库</div>
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="资产使用人"
                prop="usedName">
              </el-table-column>
              <el-table-column
                label="存放区域"
                prop="holdPlace">
              </el-table-column>
            </el-table>
              <div class="block">
                    <el-pagination
                      @size-change="select"
                      @current-change="select"
                      :current-page.sync="currentPage"
                      :page-size="10"
                      layout="prev, pager, next, jumper"
                      :total="pageSize">
                    </el-pagination>
                  </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false;ShowTableData()">确 定</el-button>
            </span>
          </el-dialog>
      </el-container>
      <el-container style="margin-top: 2%;">
        <el-empty style="margin-left: 45%;" v-if="UseTableData.length == 0" description="暂无数据"></el-empty>
        <el-table
           height="250"
           v-show="UseTableData.length != 0"
           :data="UseTableData.slice(0,10)"
           style="width: 100%">
           <el-table-column type="expand">
             <template slot-scope="props">
               <el-form label-position="left" inline class="demo-table-expand">
                 <el-form-item label="资产主键ID">
                   <span>{{ props.row.propertyId }}</span>
                 </el-form-item>
                 <el-form-item label="单位">
                   <span>{{ props.row.unitId }}</span>
                 </el-form-item>
                 <el-form-item label="资产RFID">
                   <span>{{ props.row.propertyRfid }}</span>
                 </el-form-item>
                 <el-form-item label="规格">
                   <span>{{ props.row.propertySpecification }}</span>
                 </el-form-item>
                 <el-form-item label="型号">
                   <span>{{ props.row.propertyModel }}</span>
                 </el-form-item>
                 <el-form-item label="账外资产">
                   <span>{{ props.row.outPorperty }}</span>
                 </el-form-item>
                 <el-form-item label="资产类别Id">
                   <span>{{ props.row.propertyTypeId }}</span>
                 </el-form-item>
                 <el-form-item label="存放区域ID">
                   <span>{{ props.row.placeId }}</span>
                 </el-form-item>
                 <el-form-item label="管理员Id">
                   <span>{{ props.row.managerId }}</span>
                 </el-form-item>
                 <el-form-item label="存放地点">
                   <span>{{ props.row.holdPlace }}</span>
                 </el-form-item>
                 <el-form-item label="管理员部门Id">
                   <span>{{ props.row.managerDeptId }}</span>
                 </el-form-item>
                 <el-form-item label="管理员部门名称">
                   <span>{{ props.row.managerDeptName }}</span>
                 </el-form-item>
                 <el-form-item label="管理员名称">
                   <span>{{ props.row.managerName }}</span>
                 </el-form-item>
                 <el-form-item label="资产类别mgrName">
                   <span>{{ props.row.mgrName }}</span>
                 </el-form-item>
                 <el-form-item label="帐外资产">
                   <span>{{ props.row.outProperty }}</span>
                 </el-form-item>
                 <el-form-item label="管理员部门Id">
                   <span>{{ props.row.ownerDeptId }}</span>
                 </el-form-item>
                 <el-form-item label="管理员Id">
                   <span>{{ props.row.ownerId }}</span>
                 </el-form-item>
                 <el-form-item label="单位名称">
                   <span>{{ props.row.unitName }}</span>
                 </el-form-item>
                 <el-form-item label="用户部门名称">
                   <span>{{ props.row.usedDeptName }}</span>
                 </el-form-item>
               </el-form>
             </template>
           </el-table-column>

           <el-table-column
             label="资产固定编码"
             prop="propertyCode">
           </el-table-column>
           <el-table-column
             label="资产名称"
             prop="propertyName">
           </el-table-column>
           <el-table-column
             label="资产状态"
             prop="propertyState"
             >
             <template slot-scope="scope">
               <el-tag
               :type="scope.row.propertyState == 1?''
               :(scope.row.propertyState==2?'success'
               :(scope.row.propertyState==3?'info'
               :(scope.row.propertyState==4?'danger'
               :(scope.row.properyState==5?''
               :(scope.row.properyState == 6?'success'
               :(scope.row.properyState==7?'info'
               :(scope.row.properyState==8?''
               :(scope.row.properyState==9?'warning'
               :(scope.row.properyState==10?'danger':'warning')))))))))"
               effect="dark">
                 <div v-if="scope.row.propertyState == 1">在用</div>
                 <div v-if="scope.row.propertyState == 2">待修</div>
                 <div v-if="scope.row.propertyState == 3">在修</div>
                 <div v-if="scope.row.propertyState == 4">备用</div>
                 <div v-if="scope.row.propertyState == 5">闲置</div>
                 <div v-if="scope.row.propertyState == 6">调剂</div>
                 <div v-if="scope.row.propertyState == 7">待报废</div>
                 <div v-if="scope.row.propertyState == 8">报废</div>
                 <div v-if="scope.row.propertyState == 9">待确定</div>
                 <div v-if="scope.row.propertyState == 10">在库</div>
               </el-tag>
             </template>
           </el-table-column>
           <el-table-column
             label="资产使用人"
             prop="usedName">
           </el-table-column>

           <el-table-column
             label="资产创建时间"
             prop="createDate">
           </el-table-column>
           <el-table-column
             label="资产修改时间"
             prop="updateDate">
           </el-table-column>

          <div class="block">
              <el-pagination
                @size-change="select"
                @current-change="select"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="pageSize">
              </el-pagination>
            </div>
         </el-table>
      </el-container>




      <div style="margin-left: 90%;margin-top: 2%;">
        <el-button type="success"
        @click="
        submitForm('form')">下一步</el-button>
      </div>




  </div>

</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'CheckCreateNew',
     data () {
       const data = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];
       const PlaceData = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];

       return {
         dialogPropertyTypeId:false,
         drawer: false,
         dialogManager:false,
         dialogVisible:false,
         currentPage: 1,
         pageSize:1,

         filterText: '',
         selectCheck:'',
         ManagerUser:'',
         sortMode:'',
         PlaceId:'',
         SplaceId:'',
         SpropertyName:'',
         SpropertyCode:'',
         SpropertyTypeId:'',

         SownerName:'',
         SunitId:'',
         SpropertyState:'',
         SoutProperty:'',
         SplaceRealId:"",


        option:[{
          label:"按照资产管理部门划分",
          value:'1'
        },{
          label:"按照资产类别划分",
          value:'2'
        },{
          label:"按照管理人分类",
          value:'3'
        },{
          label:"按照存放区域分类",
          value:'4'
        }],
        DName:[{
          departmentId:'',
          departmentName:'',
        }],
        DUnit:[{
          unitName:'',
          unitId:'',
        }],
        dialogPlace:false,
        PlaceData: JSON.parse(JSON.stringify(PlaceData)),
        data: JSON.parse(JSON.stringify(data)),

        id:'',
         SelectData:[{
            placeId:'',
            propertyCode:'',
            propertyName:'',
            usedName:'',
            propertyState:'',
            propertyTypeId:'',
            unitId:'',
         }],
         SForm:{
           SpropertyName:'',
           SpropertyCode:'',
           SpropertyTypeId:'',
           SplaceId:'',
           SownerId:'',
           SunitId:'',
           SpropertyState:'',
           SoutProperty:'',
           SplaceRealId:"",
         },
		UseTableData:'',


        // UseTableData:[{
        //  createDate:'',
        //   del:'',
        //   holdPlace:'',
        //   managerDeptId:'',
        //   managerDeptName:'',
        //   managerId:'',
        //   managerName:'',
        //   mgrName:'',
        //   outProperty:'',
        //   ownerDeptId:'',
        //   ownerId:'',
        //   placeId:'',
        //   propertyCode:'',
        //   propertyId:'',
        //   propertyModel:'',
        //   propertyName:'',
        //   propertyRfid:'',
        //   propertySpecification:'',
        //   propertyState:'',
        //   propertyType:'',
        //   propertyTypeId:'',
        //   unitId:'',
        //   unitName:'',
        //   usedDeptName:'',
        //   updateDate:'',
        //   usedName:'',

        // }],
        defaultProps: {
                 children: 'children',
                 label: 'label'
               },
        DName:[{
          departmentId:'',
          departmentName:'',
        }],
        DUnit:[{
          unitName:'',
          unitId:'',
        }],
        MangerData: [{
          id:'',
          label: '',
          realId:'',
          operator:'',
          children: [{
            id:'',
            label: '',
            realId:'',
            operator:'',
            children: [{
              id:'',
              label: '',
              realId:'',
              operator:'',
            }]
          }]
        }],


          BlockSelection:[],

          form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                  },

           rules: {
                    name: [
                      { required: true, message: '请输入盘点名称', trigger: 'blur' },
                      { min: 0, max: 35, message: '长度在 0 到 35 个字符', trigger: 'blur' }
                    ],
                    type: [
                      { type: 'array', required: true, message: '请至少选择一个盘点方式', trigger: 'change' }
                    ],
                    desc: [
                      { required: true, message: '请填写盘点详细信息', trigger: 'blur' }
                    ]
                  }
        };
     },
     mounted:function() {
       this.showData();
       this.showDepartmentData();
       this.showUnitData();
       this.showMData();
       this.showPlaceData();
       this.showFData();

     },
     watch: {
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
     methods: {
      resetForm(formName) {
		this.ManagerUser = null
		this.id = null
        Object.assign(this.$data.SForm, this.$options.data().SForm)
        this.showData()()
          },

       submitForm(form) {
         console.log(form)
               this.$refs[form].validate((valid) => {
                 if (valid) {
                  this.Next()
                 } else {
                   alert("填写信息有误请重新认真填写")
                   return false;
                 }
               });
             },

      BlockSelectionChange(val) {
          this.BlockSelection = val;
        },

        handleCommand(command) {

               this.selectCheck = command
              },
      TreePropertyClick(data){
            this.id = data.id
            this.SForm.SpropertyTypeId = data.label
      },
      Next(){
        var authorization = Cookies.get("Authorization");
        var searchDTO = {
          propertyName:this.SForm.SpropertyName|| null,
          propertyCode:this.SForm.SpropertyCode|| null,
          propertyTypeId:this.id || null,
          placeId:this.SForm.SplaceRealId || null,
          ownerId:this.ManagerUser|| null,
          unitId:this.SForm.SunitId|| null,
          propertyState:this.SForm.SpropertyState|| null,
        }

        var paramsData = {
          searchDTO:searchDTO,
          sortMode:4
        }
         this.axios({
             method: 'POST',
             url: '/check/sortByDto',
             data:paramsData,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'
             	}
           }).then((resp)=>{
              this.$parent.taskData = resp.data.data
              this.$parent.searchDTO = searchDTO

              this.$parent.New=2
              this.$parent.Change(2);

           })

         this.$parent.taskName = this.form.name
      },
      TreePlaceClick(data){
          this.SForm.SplaceRealId = data.id
          this.SForm.SplaceId = data.label

      },

      TreeMangerClick(data){
          if(data.operator == 1){
           this.ManagerUser = data.realId
           this.SForm.SownerId = data.label
           this.dialogManager =false
          }else{
            return;
          }
      },




      TreeOutPlaceClick(data){
          this.OutPlaceId = data.label
      },
      filterNode(value, data) {
              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },
        showFData(){
         var authorization = Cookies.get("Authorization");

          this.axios({
              method: 'GET',
              url: '/public/getPropertySortTree',
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'
              	}
            }).then((resp)=>{
             this.data=resp.data.data;
            })
        },

        showMData(){
         var authorization = Cookies.get("Authorization");
          this.axios({
              method: 'GET',
              url: '/public/getUnitTree',
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'
              	}
            }).then((resp)=>{
             var arr = new Array(resp.data.data) ;
             this.MangerData=resp.data.data;
             this.UserData = resp.data.data;
            })
        },

        showPlaceData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getTree',

              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'
              	}
            }).then((resp)=>{

             this.PlaceData=resp.data.data;
            })
        },




         showDepartmentData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 5,
          }
           this.axios({
               method: 'GET',
               url: '/public/getCanHandleDepartmentList',
               params:params,
               header:{
                'Authorization':authorization,
                'Content-Type':'application/json;charset=UTF-8'
               	}
             }).then((resp)=>{
              this.DName = resp.data.data;

             })
         },



         showPlaceData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 5,
          }
           this.axios({
               method: 'GET',
               url: '/public/getTree',

               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
              this.PlaceData=resp.data.data;
             })
         },



         showUnitData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 5,
          }
           this.axios({
               method: 'GET',
               url: '/public/getCanWatchUnit',
               params:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
              this.DUnit = resp.data.data;
             })
         },





        select(val){
           var authorization = Cookies.get("Authorization");
           var paramsData = {
             currentPage: val || 1 ,
             pageSize: 10,
             propertyName:this.SForm.SpropertyName || undefined,
             propertyCode:this.SForm.SpropertyCode || undefined,
             propertyTypeId:this.id || undefined,
             placeId:this.SForm.SplaceRealId || undefined,
             ownerId:this.ManagerUser || undefined,
             unitId:this.SForm.SunitId || undefined,
             propertyState:this.SForm.SpropertyState || undefined,
             outProperty:this.SForm.SoutProperty || undefined,
           }
            this.axios({
                method: 'GET',
                url: '/property/showPropertyMsg',
                params:paramsData,
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
                 this.SelectData = resp.data.data;
                 this.pageSize = resp.data.count;
              })
        },


        ShowTableData(){
          var authorization = Cookies.get("Authorization");
          var paramsData = {
            // currentPage: 1 ,
            // pageSize: 10,
            propertyName:this.SForm.SpropertyName || undefined,
            propertyCode:this.SForm.SpropertyCode || undefined,
            propertyTypeId:this.id || undefined,
            placeId:this.SForm.SplaceRealId || undefined,
            ownerId:this.ManagerUser || undefined,
            unitId:this.SForm.SunitId || undefined,
            propertyState:this.SForm.SpropertyState || undefined,
            outProperty:this.SForm.SoutProperty || undefined,
          }
           this.axios({
               method: 'GET',
               url: '/property/showPropertyMsg',
               params:paramsData,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
               this.UseTableData = resp.data.data
             })
        },


        showData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 10,
          }
           this.axios({
               method: 'GET',
               url: '/property/showPropertyMsg',
               params:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
			  console.log(resp.data.data)
              this.SelectData = resp.data.data;
              this.pageSize = resp.data.count;

             })
            },
     }
   }
</script>

<style>
  .cardBolck{
    text-align: center;
    width: 250px;
    height: 150px;
    border-radius: 10px;
  }
</style>
<!-- <template>

  <div>

      <el-steps :active="1" align-center>
        <el-step title="步骤 1" description="填写盘点信息"></el-step>
        <el-step title="步骤 2" description="分配盘点任务"></el-step>
      </el-steps>
      <el-contianer>
        <el-row>
          <el-col>
            <el-form
            ref="form"
            :rules = "rules"
            :model="form"
            label-width="120px"
            style="width: 45%;margin-left: 5%;margin-top: 2%;">
              <el-form-item label="盘点单名称" style="width: 65%;" prop="name">
                <el-input v-model.trim="form.name"></el-input>
              </el-form-item>
              <el-form-item label="盘点策略" prop="data1">
                <el-card shadow="hover" class="cardBolck">
                      <div style="font-size: 20px;">自定义</div>
                      <div style="font-size: 13px;">根据自己实际盘点的业务场景，自定义盘点规则</div>
                    </el-card>
              </el-form-item>

              <el-form-item label="盘点规则"  prop="type">
                <el-checkbox-group v-model="form.type" style="width: 20%;">
                  <el-checkbox label="允许手动盘点" name="type"></el-checkbox>
                  <el-checkbox label="盘点时允许修改资产信息" name="type"></el-checkbox>
                  <el-checkbox label="盘点时要求对每条资产拍照" name="type"></el-checkbox>
                  <el-checkbox label="盘点数据过滤[维修中]资产" name="type"></el-checkbox>
                  <el-checkbox label="盘点数据过滤[已处置]资产" name="type"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>


              <el-form-item label="盘点单备注" prop="desc">
                <el-input type="textarea" v-model.trim="form.desc"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-contianer>

      <el-container style="margin-top: 3%;">
          <el-col :span="3" :offset="1">待盘点数据{{UseTableData.length}}条</el-col>
          <el-col :span="2" :offset="16">清空</el-col>

          <el-col :span="2":offset="0.5" style="color: brown;">
            <i @click="dialogVisible = true"
           class="el-icon-caret-bottom">选择资产</i></el-col>



          <el-dialog
            title="选择资产"
            :visible.sync="dialogVisible"
            width="60%">


           <el-container class="SelectBlock">
             <el-col class="FirstBlock" :sapn="3" >
               <el-dropdown @command="handleCommand">
                 <span class="el-dropdown-link">
                   选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
                 </span>
                 <el-dropdown-menu slot="dropdown">
                   <el-dropdown-item command="a">根据资产名称查询</el-dropdown-item>
                   <el-dropdown-item command="b">根据使用人姓名ID查询</el-dropdown-item>
                   <el-dropdown-item command="c">根据资产固定编码查询</el-dropdown-item>
                   <el-dropdown-item command="d">根据类别查询</el-dropdown-item>
                   <el-dropdown-item command="e">根据存放的区域查询</el-dropdown-item>
                   <el-dropdown-item command="f">根据单位查询</el-dropdown-item>
                   <el-dropdown-item command="g">根据资产状态查询</el-dropdown-item>
                 </el-dropdown-menu>
               </el-dropdown>


                 <el-input
                 v-if="selectCheck == 'a'"
                 style="width: 250px;"
                 v-model.trim="SForm.SpropertyName" placeholder="根据资产名称查询"></el-input>

                 <el-input
                 v-if="selectCheck == 'b'"
                 v-model.trim="SForm.SownerId"
                 style="width: 250px;"
                 :value="ManagerUser"
                 placeholder="根据使用人姓名ID查询">
                     <el-button
                       size="mini"
                        style="padding-right:10px"
                        slot="suffix"
                        type="text"
                       @click="dialogManager = true">选择</el-button> </el-input>
                       <el-dialog title="选择资产类别" :visible.sync="dialogManager" width="35%" append-to-body>
                         <el-tree
                           class ="TreeBlock"
                           :data="MangerData"
                           :filter-node-method="filterNode"
                           node-key="id"
                           @node-click="TreeMangerClick"
                           ref="tree"
                           :props="defaultProps"
                           default-expand-all:false
                           :expand-on-click-node="false">
                           <span class="custom-tree-node" slot-scope="{ node, data }">
                             <span>{{ node.label }}</span>
                           </span>
                         </el-tree>
                         <div slot="footer" class="dialog-footer">
                           <el-button @click="dialogManager = false">取 消</el-button>
                           <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                         </div>
                       </el-dialog>


                 <el-input
                 style="width: 250px;"
                 v-if="selectCheck == 'c'"
                 v-model.trim="SForm.SpropertyCode" placeholder="根据资产固定编码查询"></el-input>

                 <el-input
                 v-if="selectCheck == 'e'"
                 v-model.trim="SForm.SplaceId"
                 :value="SForm.SplaceRealId"
                 style="width: 250px;"
                 placeholder="根据存放的区域查询">
                     <el-button
                       size="mini"
                        style="margin-top: 5px;"
                        slot="suffix"
                        type="text"
                       @click="dialogPlace = true">选择</el-button></el-input>
                       <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%" append-to-body>
                         <el-tree
                           class ="TreeBlock"
                           :data="PlaceData"
                           :filter-node-method="filterNode"
                           node-key="id"
                           @node-click="TreePlaceClick"
                           ref="tree"
                           :props="defaultProps"
                           default-expand-all:false
                           :expand-on-click-node="false">
                           <span class="custom-tree-node" slot-scope="{ node, data }">
                             <span>{{ node.label }}</span>

                           </span>
                         </el-tree>
                         <div slot="footer" class="dialog-footer">
                           <el-button @click="dialogPlace = false">取 消</el-button>
                           <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                         </div>
                       </el-dialog>


                <el-input
                style="width: 250px;"
                v-if="selectCheck == 'd'"
                v-model.trim="SForm.SpropertyTypeId"
                placeholder="根据类别查询"
                :value="id">
                    <el-button
                      size="mini"
                       style="padding-right:10px"
                       slot="suffix"
                       type="text"
                      @click="dialogPropertyTypeId = true">选择</el-button> </el-input>
                      <el-dialog title="选择资产类别"
                      append-to-body
                      :visible.sync="dialogPropertyTypeId" width="25%">

                      <el-input
                        placeholder="输入关键字进行过滤"
                        v-model="filterText">
                      </el-input>
                        <el-tree
                          class ="TreeBlock"
                          :data="data"
                          :filter-node-method="filterNode"
                          node-key="id"
                          @node-click="TreePropertyClick"
                          ref="tree"
                          :props="defaultProps"
                          default-expand-all:false
                          :expand-on-click-node="false">
                          <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>

                          </span>
                        </el-tree>
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="dialogPropertyTypeId = false">取 消</el-button>
                          <el-button type="primary" @click="dialogPropertyTypeId = false;">确 定</el-button>
                        </div>
                      </el-dialog>








                 <el-select v-if="selectCheck == 'f'"
                 style="width: 250px;"
                 v-model.trim="SForm.SunitId" placeholder="根据单位查询">
                  <el-option
                  v-for="i in DUnit"
                  :label="i.unitName"
                  :key="i.unitId"
                  :value="i.unitId">
                  </el-option>

                  <el-select
                  v-if="selectCheck == 'h'"
                  style="width: 250px;"
                  v-model.trim="SForm.SoutProperty" placeholder="根据是否为帐外资产查询">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                 </el-select>
                 <el-select v-if="selectCheck == 'g'"
                 style="width: 250px;"
                 v-model.trim="SForm.SpropertyState" placeholder="是否为资产状态">
                   <el-option label="在用" value='1'></el-option>
                   <el-option label="待修" value='2'></el-option>
                   <el-option label="在修" value='3'></el-option>
                   <el-option label="备用" value='4'></el-option>
                   <el-option label="闲置" value='5'></el-option>
                   <el-option label="调剂" value='6'></el-option>
                   <el-option label="待报废" value='7'></el-option>

                   <el-option label="报废" value='8'></el-option>
                   <el-option label="待确定" value='9'></el-option>
                   <el-option label="在库" value='10'></el-option>

                 </el-select>
               <el-button type="primary" @click="select(1)">查询</el-button>
               <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
             </el-col>
           </el-container>















            <el-table
               :data="SelectData"
               style="width: 100%">
              <el-table-column
                label="资产固定编码"
                prop="propertyCode">
              </el-table-column>
              <el-table-column
                label="资产名称"
                prop="propertyName">
              </el-table-column>
              <el-table-column
                label="资产状态"
                prop="propertyState"
                >
                <template slot-scope="scope">
                  <el-tag
                  :type="scope.row.propertyState == 1?''
                  :(scope.row.propertyState==2?'success'
                  :(scope.row.propertyState==3?'info'
                  :(scope.row.propertyState==4?'danger'
                  :(scope.row.properyState==5?''
                  :(scope.row.properyState == 6?'success'
                  :(scope.row.properyState==7?'info'
                  :(scope.row.properyState==8?''
                  :(scope.row.properyState==9?'warning'
                  :(scope.row.properyState==10?'danger':'warning')))))))))"
                  effect="dark">
                    <div v-if="scope.row.propertyState == 1">在用</div>
                    <div v-if="scope.row.propertyState == 2">待修</div>
                    <div v-if="scope.row.propertyState == 3">在修</div>
                    <div v-if="scope.row.propertyState == 4">备用</div>
                    <div v-if="scope.row.propertyState == 5">闲置</div>
                    <div v-if="scope.row.propertyState == 6">调剂</div>
                    <div v-if="scope.row.propertyState == 7">待报废</div>
                    <div v-if="scope.row.propertyState == 8">报废</div>
                    <div v-if="scope.row.propertyState == 9">待确定</div>
                    <div v-if="scope.row.propertyState == 10">在库</div>
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="资产使用人"
                prop="usedName">
              </el-table-column>
              <el-table-column
                label="存放区域ID"
                prop="placeId">
              </el-table-column>
            </el-table>
              <div class="block">
                    <el-pagination
                      @size-change="select"
                      @current-change="select"
                      :current-page.sync="currentPage"
                      :page-size="10"
                      layout="prev, pager, next, jumper"
                      :total="pageSize">
                    </el-pagination>
                  </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false;ShowTableData()">确 定</el-button>
            </span>
          </el-dialog>






      </el-container>


      <el-container style="margin-top: 2%;">
        <el-empty style="margin-left: 45%;" v-if="UseTableData.length == 1" description="暂无数据"></el-empty>
        <el-table
           height="250"
           v-show="UseTableData.length != 1"
           :data="UseTableData"
           style="width: 100%">
           <el-table-column type="expand">
             <template slot-scope="props">
               <el-form label-position="left" inline class="demo-table-expand">
                 <el-form-item label="资产主键ID">
                   <span>{{ props.row.propertyId }}</span>
                 </el-form-item>
                 <el-form-item label="单位">
                   <span>{{ props.row.unitId }}</span>
                 </el-form-item>
                 <el-form-item label="资产RFID">
                   <span>{{ props.row.propertyRfid }}</span>
                 </el-form-item>
                 <el-form-item label="规格">
                   <span>{{ props.row.propertySpecification }}</span>
                 </el-form-item>
                 <el-form-item label="型号">
                   <span>{{ props.row.propertyModel }}</span>
                 </el-form-item>
                 <el-form-item label="账外资产">
                   <span>{{ props.row.outPorperty }}</span>
                 </el-form-item>
                 <el-form-item label="资产类别Id">
                   <span>{{ props.row.propertyTypeId }}</span>
                 </el-form-item>
                 <el-form-item label="存放区域ID">
                   <span>{{ props.row.placeId }}</span>
                 </el-form-item>
                 <el-form-item label="管理员Id">
                   <span>{{ props.row.managerId }}</span>
                 </el-form-item>
                 <el-form-item label="存放地点">
                   <span>{{ props.row.holdPlace }}</span>
                 </el-form-item>
                 <el-form-item label="管理员部门Id">
                   <span>{{ props.row.managerDeptId }}</span>
                 </el-form-item>
                 <el-form-item label="管理员部门名称">
                   <span>{{ props.row.managerDeptName }}</span>
                 </el-form-item>
                 <el-form-item label="管理员名称">
                   <span>{{ props.row.managerName }}</span>
                 </el-form-item>
                 <el-form-item label="资产类别mgrName">
                   <span>{{ props.row.mgrName }}</span>
                 </el-form-item>
                 <el-form-item label="帐外资产">
                   <span>{{ props.row.outProperty }}</span>
                 </el-form-item>
                 <el-form-item label="管理员部门Id">
                   <span>{{ props.row.ownerDeptId }}</span>
                 </el-form-item>
                 <el-form-item label="管理员Id">
                   <span>{{ props.row.ownerId }}</span>
                 </el-form-item>
                 <el-form-item label="单位名称">
                   <span>{{ props.row.unitName }}</span>
                 </el-form-item>
                 <el-form-item label="用户部门名称">
                   <span>{{ props.row.usedDeptName }}</span>
                 </el-form-item>
               </el-form>
             </template>
           </el-table-column>

           <el-table-column
             label="资产固定编码"
             prop="propertyCode">
           </el-table-column>
           <el-table-column
             label="资产名称"
             prop="propertyName">
           </el-table-column>
           <el-table-column
             label="资产状态"
             prop="propertyState"
             >
             <template slot-scope="scope">
               <el-tag
               :type="scope.row.propertyState == 1?''
               :(scope.row.propertyState==2?'success'
               :(scope.row.propertyState==3?'info'
               :(scope.row.propertyState==4?'danger'
               :(scope.row.properyState==5?''
               :(scope.row.properyState == 6?'success'
               :(scope.row.properyState==7?'info'
               :(scope.row.properyState==8?''
               :(scope.row.properyState==9?'warning'
               :(scope.row.properyState==10?'danger':'warning')))))))))"
               effect="dark">
                 <div v-if="scope.row.propertyState == 1">在用</div>
                 <div v-if="scope.row.propertyState == 2">待修</div>
                 <div v-if="scope.row.propertyState == 3">在修</div>
                 <div v-if="scope.row.propertyState == 4">备用</div>
                 <div v-if="scope.row.propertyState == 5">闲置</div>
                 <div v-if="scope.row.propertyState == 6">调剂</div>
                 <div v-if="scope.row.propertyState == 7">待报废</div>
                 <div v-if="scope.row.propertyState == 8">报废</div>
                 <div v-if="scope.row.propertyState == 9">待确定</div>
                 <div v-if="scope.row.propertyState == 10">在库</div>
               </el-tag>
             </template>
           </el-table-column>
           <el-table-column
             label="资产使用人"
             prop="usedName">
           </el-table-column>

           <el-table-column
             label="资产创建时间"
             prop="createDate">
           </el-table-column>
           <el-table-column
             label="资产修改时间"
             prop="updateDate">
           </el-table-column>

          <div class="block">
              <el-pagination
                @size-change="select"
                @current-change="select"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="pageSize">
              </el-pagination>
            </div>
         </el-table>
      </el-container>




      <div style="margin-left: 90%;margin-top: 2%;">
        <el-button type="success"
        @click="
        submitForm('form')">下一步</el-button>
      </div>




  </div>

</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'CheckCreateNew',
     data () {
       const data = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];
       const PlaceData = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];

       return {
         dialogPropertyTypeId:false,
         drawer: false,
         dialogManager:false,
         dialogVisible:false,
         currentPage: 1,
         pageSize:1,

         filterText: '',
         selectCheck:'',
         ManagerUser:'',
         sortMode:'',
         PlaceId:'',
         SplaceId:'',
         SpropertyName:'',
         SpropertyCode:'',
         SpropertyTypeId:'',

         SownerName:'',
         SunitId:'',
         SpropertyState:'',
         SoutProperty:'',
         SplaceRealId:"",


        option:[{
          label:"按照资产管理部门划分",
          value:'1'
        },{
          label:"按照资产类别划分",
          value:'2'
        },{
          label:"按照管理人分类",
          value:'3'
        },{
          label:"按照存放区域分类",
          value:'4'
        }],
        DName:[{
          departmentId:'',
          departmentName:'',
        }],
        DUnit:[{
          unitName:'',
          unitId:'',
        }],
        dialogPlace:false,
        PlaceData: JSON.parse(JSON.stringify(PlaceData)),
        data: JSON.parse(JSON.stringify(data)),

        id:'',
         SelectData:[{
            placeId:'',
            propertyCode:'',
            propertyName:'',
            usedName:'',
            propertyState:'',
            propertyTypeId:'',
            unitId:'',
         }],
         SForm:{
           SpropertyName:'',
           SpropertyCode:'',
           SpropertyTypeId:'',
           SplaceId:'',
           SownerId:'',
           SunitId:'',
           SpropertyState:'',
           SoutProperty:'',
           SplaceRealId:"",
         },



        UseTableData:[{
         createDate:'',
          del:'',
          holdPlace:'',
          managerDeptId:'',
          managerDeptName:'',
          managerId:'',
          managerName:'',
          mgrName:'',
          outProperty:'',
          ownerDeptId:'',
          ownerId:'',
          placeId:'',
          propertyCode:'',
          propertyId:'',
          propertyModel:'',
          propertyName:'',
          propertyRfid:'',
          propertySpecification:'',
          propertyState:'',
          propertyType:'',
          propertyTypeId:'',
          unitId:'',
          unitName:'',
          usedDeptName:'',
          updateDate:'',
          usedName:'',

        }],
        defaultProps: {
                 children: 'children',
                 label: 'label'
               },
        DName:[{
          departmentId:'',
          departmentName:'',
        }],
        DUnit:[{
          unitName:'',
          unitId:'',
        }],
        MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],


          BlockSelection:[],

          form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                  },

           rules: {
                    name: [
                      { required: true, message: '请输入盘点名称', trigger: 'blur' },
                      { min: 0, max: 35, message: '长度在 0 到 35 个字符', trigger: 'blur' }
                    ],
                    type: [
                      { type: 'array', required: true, message: '请至少选择一个盘点方式', trigger: 'change' }
                    ],
                    desc: [
                      { required: true, message: '请填写盘点详细信息', trigger: 'blur' }
                    ]
                  }
        };
     },
     mounted:function() {
		// 首先是当页面加载的时候自动渲染这些数据
			 
       this.showData();
       this.showDepartmentData();
       this.showUnitData();
       this.showMData();
       this.showPlaceData();
       this.showFData();

     },
     watch: {
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
     methods: {
		 // 重置清空所有数据
      resetForm(formName) {
        Object.assign(this.$data.SForm, this.$options.data().SForm)
        this.showData()()
          },
	   // 提交功能
       submitForm(form) {
               this.$refs[form].validate((valid) => {
                 if (valid) {
                  this.Next()
                 } else {
                   alert("填写信息有误请重新认真填写")
                   return false;
                 }
               });
             },

		// 下拉菜单存放点击时选中的数据
        handleCommand(command) {
               this.selectCheck = command
              },
			  
			  
			  
			  
			  
	  // 获取资产类别信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是资产类别ID		  
      TreePropertyClick(data){
            this.id = data.id
            this.SForm.SpropertyTypeId = data.label
      },
	  
	  
	  // 下一步的跳转和数据传输功能
      Next(){
        var authorization = Cookies.get("Authorization");
        var searchDTO = {
          propertyName:this.SForm.SpropertyName|| null,
          propertyCode:this.SForm.SpropertyCode|| null,
          propertyTypeId:this.id || null,
          placeId:this.SForm.SplaceRealId || null,
          ownerId:this.ManagerUser|| null,
          unitId:this.SForm.SunitId|| null,
          propertyState:this.SForm.SpropertyState|| null,
        }

        var paramsData = {
          searchDTO:searchDTO,
          sortMode:4
        }
         this.axios({
             method: 'POST',
             url: '/check/sortByDto',
             data:paramsData,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'
             	}
           }).then((resp)=>{
              this.$parent.taskData = resp.data.data
              this.$parent.searchDTO = searchDTO

              this.$parent.New=2
              this.$parent.Change(2);

           })

         this.$parent.taskName = this.form.name
      },
	   // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
      TreePlaceClick(data){
          this.SForm.SplaceRealId = data.id
          this.SForm.SplaceId = data.label

      },
	  // 获取管理人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是管理人ID
      TreeMangerClick(data){
          this.ManagerUser = data.realId
          this.SForm.SownerId = data.label
      },
	  // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
      TreeOutPlaceClick(data){
          this.OutPlaceId = data.label
      },
	  
	  
	  
      filterNode(value, data) {
              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },
			
			
		// 资产类别树的获取，并写入data中
        showFData(){
         var authorization = Cookies.get("Authorization");

          this.axios({
              method: 'GET',
              url: '/public/getPropertySortTree',
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'
              	}
            }).then((resp)=>{
             this.data=resp.data.data;
            })
        },
		// 请求小杜接口/public/getUnitTree获取区域信息然后将数据传给MangerData
        showMData(){
         var authorization = Cookies.get("Authorization");
          this.axios({
              method: 'GET',
              url: '/public/getUnitTree',
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'
              	}
            }).then((resp)=>{
             // var arr = new Array(resp.data.data) ;
             this.MangerData=resp.data.data;
             this.UserData = resp.data.data;
            })
        },
		// 请求小杜接口/public/getTree获取区域信息然后将数据传给PlaceData
        showPlaceData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getTree',

              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'
              	}
            }).then((resp)=>{

             this.PlaceData=resp.data.data;
            })
        },



		// 请求小杜接口/public/getCanHandleDepartmentList获取部门信息然后将数据传给DName
         showDepartmentData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 5,
          }
           this.axios({
               method: 'GET',
               url: '/public/getCanHandleDepartmentList',
               params:params,
               header:{
                'Authorization':authorization,
                'Content-Type':'application/json;charset=UTF-8'
               	}
             }).then((resp)=>{
              this.DName = resp.data.data;

             })
         },


		// 请求小杜接口/public/getTree获取区域信息然后将数据传给PlaceData
         showPlaceData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 5,
          }
           this.axios({
               method: 'GET',
               url: '/public/getTree',

               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
              this.PlaceData=resp.data.data;
             })
         },


	     // 请求小杜接口/public/getCanWatchUnit获取单位信息然后将数据传给DUnit
         showUnitData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 5,
          }
           this.axios({
               method: 'GET',
               url: '/public/getCanWatchUnit',
               params:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
              this.DUnit = resp.data.data;
             })
         },




		// 根据条件查询查询数据都在SForm中
        select(val){
           var authorization = Cookies.get("Authorization");
           var paramsData = {
             currentPage: val || 1 ,
             pageSize: 10,
             propertyName:this.SForm.SpropertyName || undefined,
             propertyCode:this.SForm.SpropertyCode || undefined,
             propertyTypeId:this.id || undefined,
             placeId:this.SForm.SplaceRealId || undefined,
             ownerId:this.ManagerUser || undefined,
             unitId:this.SForm.SunitId || undefined,
             propertyState:this.SForm.SpropertyState || undefined,
             outProperty:this.SForm.SoutProperty || undefined,
           }
            this.axios({
                method: 'GET',
                url: '/property/showPropertyMsg',
                params:paramsData,
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
                console.log(resp.data.data)
                 this.SelectData = resp.data.data;
                 this.pageSize = resp.data.count;
              })
        },

		// 通过SForm里的数据传给小杜返回得到预浏览的数据
        ShowTableData(){
          var authorization = Cookies.get("Authorization");
          var paramsData = {
            // currentPage: val || 1 ,
            // pageSize: 10,
            propertyName:this.SForm.SpropertyName || undefined,
            propertyCode:this.SForm.SpropertyCode || undefined,
            propertyTypeId:this.id || undefined,
            placeId:this.SForm.SplaceRealId || undefined,
            ownerId:this.ManagerUser || undefined,
            unitId:this.SForm.SunitId || undefined,
            propertyState:this.SForm.SpropertyState || undefined,
            outProperty:this.SForm.SoutProperty || undefined,
          }
           this.axios({
               method: 'GET',
               url: '/property/showPropertyMsg',
               params:paramsData,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
               this.UseTableData = resp.data.data
             })
        },

		// 展示资产所有数据
        showData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 10,
          }
           this.axios({
               method: 'GET',
               url: '/property/showPropertyMsg',
               params:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
              this.SelectData = resp.data.data;
              this.pageSize = resp.data.count;

             })
            },
     }
   }
</script>

<style>
  .cardBolck{
    text-align: center;
    width: 250px;
    height: 150px;
    border-radius: 10px;
   /* background-color: #91949b; */
  }
</style> -->



// WEBPACK FOOTER //
// src/components/Check/CheckCreateNew.vue